import styled from 'styled-components'
import { colors, derivedColors } from '../../const'

// Reutilizamos los estilos de Card de UserOption
export const LoadingCard = styled.div`
  background-color: ${colors.surface};
  box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  transition: box-shadow 0.2s;
  display: flex;
  flex-direction: column;
  height: 200px; /* Altura fija más pequeña */
  border-radius: 0.5rem;
  width: 100%;
  max-width: 300px; /* Ancho máximo para que no sea gigante */
  margin: 0 auto; /* Centrar la card */
`

export const CardContent = styled.div`
  padding: 32px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
`

export const IconWrapper = styled.div`
  width: 64px;
  height: 64px;
  background-color: ${derivedColors.subtleSurface};
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
`

export const LoadingText = styled.p`
  font-size: 0.875rem;
  color: ${colors.textSecondary};
  margin: 0;
  font-weight: 500;
`

export const OverlayContainer = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgba(255, 255, 255, 0.85); /* Semi-transparente blanco para oscurecer/bloquear el fondo */
  z-index: 9999; /* Muy alto para estar por encima de navbars, modals, etc. */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const OverlayText = styled.p`
  font-size: 1.25rem;
  color: ${colors.textSecondary};
  margin-top: 24px;
  font-weight: 600;
`
